export type Locale = "en" | "it" | "fr" | "de" | "es" | "pl" | "sr";
export type RouteName = "home" | "philosophy" | "features";

export const LOCALES: readonly Locale[] = ["en", "it", "fr", "de", "es", "pl", "sr"] as const;
export const DEFAULT_LOCALE: Locale = "en";

export const ROUTE_MANIFEST: Record<RouteName, Record<Locale, string>> = {
  home: {
    en: "/",
    it: "/it",
    fr: "/fr",
    de: "/de",
    es: "/es",
    pl: "/pl",
    sr: "/sr",
  },
  philosophy: {
    en: "/philosophy",
    it: "/it/filosofia",
    fr: "/fr/philosophie",
    de: "/de/philosophie",
    es: "/es/filosofia",
    pl: "/pl/filozofia",
    sr: "/sr/filozofija",
  },
  features: {
    en: "/features",
    it: "/it/funzionalita",
    fr: "/fr/fonctionnalites",
    de: "/de/funktionen",
    es: "/es/funcionalidades",
    pl: "/pl/funkcje",
    sr: "/sr/funkcije",
  },
};

export function pathFor(route: RouteName, locale: Locale): string {
  return ROUTE_MANIFEST[route][locale];
}

export function allPaths(): string[] {
  return Object.values(ROUTE_MANIFEST).flatMap((byLocale) => Object.values(byLocale));
}

export const BLOG_INDEX_PATH = "/blog";

export function blogPostPath(slug: string): string {
  return `/blog/${slug}`;
}

export const BLOG_LOCALE_PREFIXES: readonly string[] = [
  "/it",
  "/fr",
  "/de",
  "/es",
  "/pl",
  "/sr",
] as const;
